// extracted by mini-css-extract-plugin
module.exports = {"tag":"_japMRZjB"};